import { UserLocaleCode } from "@/shared/@types/UserLocaleCode";
import { setupI18n } from "@/shared/i18n/setupI18n";
import de from "./locales/de";
import deAT from "./locales/de-AT";
import deCH from "./locales/de-CH";
import en from "./locales/en";
import fr from "./locales/fr";
import frBE from "./locales/fr-BE";
import frCH from "./locales/fr-CH";
import itCH from "./locales/it-CH";
import nl from "./locales/nl";
import nlBE from "./locales/nl-BE";

export const i18nInstance = setupI18n({
  messages: {
    [UserLocaleCode.DE]: de,
    [UserLocaleCode.DE_AT]: deAT,
    [UserLocaleCode.DE_CH]: deCH,
    [UserLocaleCode.EN]: en,
    [UserLocaleCode.FR]: fr,
    [UserLocaleCode.FR_BE]: frBE,
    [UserLocaleCode.FR_CH]: frCH,
    [UserLocaleCode.IT_CH]: itCH,
    [UserLocaleCode.NL]: nl,
    [UserLocaleCode.NL_BE]: nlBE,
  },
});

export const i18n = i18nInstance.global;
